module.exports = __webpack_public_path__ + "img/24.2cdf862f.svg";